(() => {
  const plans = {1:714543595903,2:714543628671,3:714543661439,4:714543694207,6:714543726975};
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-bs-data]').textContent);
    const q = s => root.querySelector(s), qa = s => [...root.querySelectorAll(s)];
    const labels = data.labels;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:data.currency}).format(cents / 100);
    const replace = (s, values) => Object.entries(values).reduce((text,[k,v])=>text.replaceAll('['+k+']',v),s);
    const initial = data.variants.find(v=>v.available && v.title==='Summer Bloom') || data.variants.find(v=>v.available);
    const state = {quantity:data.defaultQuantity,sub:true,frequency:data.defaultQuantity,counts:{},busy:false};
    data.variants.forEach(v=>state.counts[v.id]=0);
    if (initial) state.counts[initial.id]=state.quantity;
    const count = () => Object.values(state.counts).reduce((a,b)=>a+b,0);
    const alloc = v => v.plans.find(p=>p.id===plans[state.frequency]);
    const unit = v => state.sub ? alloc(v)?.price : v.price;
    // Existing Skio volume rules: 2 packs save 2, 3 save 4, 4 save 6 (GBP/EUR).
    const discount = n => ['GBP','EUR'].includes(data.currency) ? Math.max(0,Math.min(n,4)-1)*200 : 0;
    const total = () => Math.max(0,data.variants.reduce((n,v)=>n+(unit(v)||0)*state.counts[v.id],0)-discount(count()));
    function render() {
      const selected=count(), price=total(), retail=data.variants.reduce((n,v)=>n+v.price*state.counts[v.id],0);
      const giftValue=state.sub?((selected>=1?data.giftValue.ebook:0)+(selected>=2?data.giftValue.tin:0)+(selected>=3?data.giftValue.frog:0)+(selected>=4?data.giftValue.shipping:0)):0;
      const value=retail+giftValue;
      const percent=value?Math.floor((value-price)/value*100):0;
      const valid=selected===state.quantity && selected>0 && data.variants.every(v=>!state.counts[v.id] || (v.available && Number.isFinite(unit(v))));
      const representative=data.variants.find(v=>state.counts[v.id]) || initial || data.variants[0];
      qa('[data-bs-tier-wash]').forEach(el=>{
        const n=Number(el.dataset.bsTierWash);
        const per=Math.ceil(Math.max(0,(unit(representative)||representative.price)*n-discount(n))/(n*60));
        el.textContent=replace(labels.perWash,{price:money(per)});
      });
      q('[data-bs-flex-title]').textContent=state.sub?replace(labels.flex,{percent}):labels.once;
      q('[data-bs-flex]').setAttribute('aria-label',state.sub?replace(labels.flex,{percent}):labels.flex.replace('[percent]','20'));
      q('[data-bs-flex-detail]').textContent=state.sub?labels.flexDetail:labels.onceDetail;
      q('[data-bs-frequency-wrap]').hidden=!state.sub;
      q('[data-bs-frequency]').value=String(state.frequency);
      q('[data-bs-selected]').textContent=replace(labels.selected,{selected,total:state.quantity});
      qa('[data-bs-variant]').forEach(row=>{
        const id=Number(row.dataset.bsVariant), v=data.variants.find(v=>v.id===id), amount=state.counts[id];
        row.querySelector('[data-bs-count]').textContent=amount;
        row.querySelector('[data-bs-minus]').disabled=amount===0 || state.busy;
        row.querySelector('[data-bs-plus]').disabled=!v.available || amount===state.quantity || state.busy;
        row.classList.toggle('is-chosen',amount>0);
      });
      q('[data-bs-total]').textContent=money(price);
      q('[data-bs-retail]').textContent=money(value);
      q('[data-bs-value-label]').textContent=state.sub?labels.fullValue:labels.fullPrice;
      q('[data-bs-retail]').hidden=value<=price;
      q('[data-bs-saving]').textContent=replace(labels.save,{percent});
      q('[data-bs-saving]').hidden=value<=price;
      q('[data-bs-wash]').textContent=selected?replace(labels.perWash,{price:money(Math.ceil(price/(selected*60)))}):'';
      document.querySelectorAll('[data-bs-comparison-wash]').forEach(el=>{el.textContent=selected?replace(labels.perWash,{price:money(Math.ceil(price/(selected*60)))}).replace(' / wash*',''):'—';});
      q('[data-bs-shipping]').textContent=price>data.threshold?labels.freeShipping:labels.paidShipping;
      q('[data-bs-renewal]').textContent=state.sub?replace(labels.renewal,{price:money(price),frequency:q('[data-bs-frequency]').selectedOptions[0].textContent}):labels.onceNote;
      q('[data-bs-atc]').disabled=!valid || state.busy;
      q('[data-bs-atc]').textContent=state.busy?labels.adding:(valid?labels.atc+' →':replace(labels.chooseMore,{count:state.quantity-selected}));
      q('[data-bs-sticky-price]').textContent=money(price);
      q('[data-bs-sticky-selection]').textContent=replace(labels.packs,{count:state.quantity})+' · '+(state.sub?'FlexPlan':labels.once);
      q('[data-bs-sticky-atc]').disabled=state.busy;
      q('[data-bs-gifts]').hidden=!state.sub;
      q('[data-bs-gift-summary]').textContent=replace(labels.giftSummary,{count:Math.min(selected,4)});
      qa('[data-bs-gift-tier]').forEach(card=>{
        const tier=Number(card.dataset.bsGiftTier),locked=tier>selected;
        card.classList.toggle('is-locked',locked);
        const status=card.querySelector('[data-bs-gift-status]');
        status.replaceChildren(document.createTextNode(locked?labels.unlock:labels.free));
        const giftPrice=[0,data.giftValue.ebook,data.giftValue.tin,data.giftValue.frog,data.giftValue.shipping][tier];
        if(giftPrice){const strike=document.createElement('s');strike.textContent=money(giftPrice);status.append(' ',strike);}
      });
      q('[data-bs-sheets-value]').textContent=money(retail);
      q('[data-bs-gift-value]').textContent=money(giftValue);
      q('[data-bs-gift-value-row]').hidden=!state.sub;
      q('[data-bs-full-value]').textContent=money(value);
      q('[data-bs-value-detail-label]').textContent=state.sub?labels.fullValue:labels.fullPrice;
      q('[data-bs-paid-value]').textContent=money(price);
      const variants=data.variants.filter(v=>state.counts[v.id]);
      if(variants.length===1){q('[name="id"]').value=variants[0].id;q('[name="quantity"]').value=state.quantity;}
      return valid;
    }
    root.addEventListener('change',event=>{
      if(event.target.matches('[name="bs_quantity"]')){
        state.quantity=Number(event.target.value);state.frequency=state.quantity;
        let excess=count()-state.quantity;
        [...data.variants].reverse().forEach(v=>{const remove=Math.min(Math.max(0,excess),state.counts[v.id]);state.counts[v.id]-=remove;excess-=remove;});
        const top=data.variants.find(v=>state.counts[v.id]>0 && v.available)||initial;
        if(top && count()<state.quantity)state.counts[top.id]+=state.quantity-count();
      }
      if(event.target.matches('[data-bs-flex]'))state.sub=event.target.checked;
      if(event.target.matches('[data-bs-frequency]'))state.frequency=Number(event.target.value);
      q('[data-bs-error]').hidden=true;render();
    });
    root.addEventListener('click',event=>{
      const control=event.target.closest('[data-bs-plus],[data-bs-minus]');if(!control || state.busy)return;
      const id=Number(control.closest('[data-bs-variant]').dataset.bsVariant);
      if(control.hasAttribute('data-bs-minus'))state.counts[id]=Math.max(0,state.counts[id]-1);
      else {
        if(count()===state.quantity){const donor=data.variants.filter(v=>v.id!==id && state.counts[v.id]>0).sort((a,b)=>state.counts[b.id]-state.counts[a.id])[0];if(donor)state.counts[donor.id]--;}
        if(count()<state.quantity)state.counts[id]++;
      }
      q('[data-bs-error]').hidden=true;render();
    });
    q('.bs-form').addEventListener('submit',async event=>{
      event.preventDefault();if(state.busy || !render())return;
      const items=data.variants.filter(v=>state.counts[v.id]).map(v=>({id:v.id,quantity:state.counts[v.id],properties:{_tw_offer:'biopure_simple_gifts'},...(state.sub?{selling_plan:plans[state.frequency]}:{})}));
      if(state.sub){
        const gifts=data.gifts.filter(g=>g.tier<=state.quantity);
        if(gifts.some(g=>!g.id||!g.available||g.price!==0)){q('[data-bs-error]').textContent=labels.giftError;q('[data-bs-error]').hidden=false;return;}
        gifts.forEach(g=>items.push({id:g.id,quantity:1,properties:{_free_gift:'true',_gift_rule:'biopure_subscription_quantity'}}));
      }
      state.busy=true;render();q('[data-bs-error]').hidden=true;
      try {
        const response=await fetch(data.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const body=await response.json();
        if(!response.ok || body.status)throw new Error(body.description || labels.error);
        if(typeof window.twCartOpen==='function')window.twCartOpen();else window.location.assign(data.cartUrl);
      } catch(error) {q('[data-bs-error]').textContent=error.message || labels.error;q('[data-bs-error]').hidden=false;}
      finally {state.busy=false;render();}
    });
    const gallery=q('[data-bs-gallery]');
    qa('[data-bs-image]').forEach(button=>button.addEventListener('click',()=>gallery.scrollTo({left:gallery.clientWidth*Number(button.dataset.bsImage),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
    const galleryObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){const idx=[...gallery.children].indexOf(entry.target);qa('[data-bs-image]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.bsImage)===idx)));}}),{root:gallery,threshold:.7});
    [...gallery.children].forEach(el=>galleryObserver.observe(el));
    const sticky=q('[data-bs-sticky]');
    let frame=0;
    const updateSticky=()=>{
      frame=0;
      const rect=q('[data-bs-atc]').getBoundingClientRect();
      const inView=rect.top<window.innerHeight&&rect.bottom>0;
      sticky.hidden=inView;
      sticky.dataset.before=String(rect.top>=window.innerHeight);
      q('[data-bs-sticky-atc]').textContent=state.busy?labels.adding:labels.atc+' →';
      const preview=document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      const previewBox=preview?.getBoundingClientRect();
      sticky.style.bottom=previewBox&&previewBox.bottom>0&&previewBox.top<innerHeight?Math.max(0,innerHeight-previewBox.top)+'px':'0px';
    };
    const scheduleSticky=()=>{if(!frame)frame=requestAnimationFrame(updateSticky);};
    const previewObserver=new MutationObserver(scheduleSticky);previewObserver.observe(document.body,{childList:true});
    const visibility=new IntersectionObserver(scheduleSticky,{threshold:[0,1]});visibility.observe(q('[data-bs-atc]'));
    window.addEventListener('scroll',scheduleSticky,{passive:true});
    window.addEventListener('resize',scheduleSticky,{passive:true});
    q('[data-bs-sticky-atc]').addEventListener('click',()=>{
      if(render())q('.bs-form').requestSubmit();else q('.bs-scents').scrollIntoView({behavior:'smooth',block:'center'});
    });
    root.addEventListener('shopify:section:unload',()=>{visibility.disconnect();galleryObserver.disconnect();previewObserver.disconnect();window.removeEventListener('scroll',scheduleSticky);window.removeEventListener('resize',scheduleSticky);if(frame)cancelAnimationFrame(frame);},{once:true});
    updateSticky();
    render();
  }
  function initReasons(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const track=root.querySelector('[data-bs-reason-track]'), cards=[...root.querySelectorAll('[data-bs-reason]')];
    const prev=root.querySelector('[data-bs-reason-prev]'), next=root.querySelector('[data-bs-reason-next]');
    const progress=root.querySelector('[data-bs-reason-progress]'), status=root.querySelector('[data-bs-reason-status]');
    root.querySelector('[data-bs-reason-controls]').hidden=cards.length<2;
    let index=0,frame=0;
    const update=()=>{frame=0;const left=track.getBoundingClientRect().left;let nearest=Infinity;cards.forEach((card,i)=>{const distance=Math.abs(card.getBoundingClientRect().left-left);if(distance<nearest){nearest=distance;index=i;}});prev.disabled=index===0;next.disabled=index===cards.length-1;progress.style.width=((index+1)/cards.length*100)+'%';status.textContent=(index+1)+' / '+cards.length;};
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
    const go=offset=>{const target=cards[Math.max(0,Math.min(cards.length-1,index+offset))];track.scrollTo({left:track.scrollLeft+target.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
    prev.addEventListener('click',()=>go(-1));next.addEventListener('click',()=>go(1));
    track.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
    track.addEventListener('keydown',event=>{if(event.target!==track||!matchMedia('(max-width:899px)').matches)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(event.key==='ArrowRight'?1:-1);}});
    const section=root.closest('.shopify-section');
    const select=event=>{const card=event.target.closest('[data-bs-reason]');if(card&&track.contains(card)&&matchMedia('(max-width:899px)').matches){index=cards.indexOf(card);go(0);}};
    section?.addEventListener('shopify:block:select',select);
    section?.addEventListener('shopify:section:unload',()=>{window.removeEventListener('resize',schedule);track.removeEventListener('scroll',schedule);section.removeEventListener('shopify:block:select',select);if(frame)cancelAnimationFrame(frame);},{once:true});
    update();
  }
  function initReveal(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const range=root.querySelector('.bs-reveal-range');
    const update=()=>root.style.setProperty('--reveal',range.value+'%');
    let pointer=null;
    const move=event=>{
      const box=root.getBoundingClientRect();
      range.value=String(Math.round(Math.max(0,Math.min(100,(event.clientX-box.left)/box.width*100))));
      update();
    };
    range.addEventListener('input',update);
    root.addEventListener('pointerdown',event=>{
      if(!event.isPrimary||event.button!==0)return;
      pointer=event.pointerId;root.setPointerCapture(pointer);
      range.focus({preventScroll:true});move(event);
    });
    root.addEventListener('pointermove',event=>{if(pointer===event.pointerId)move(event);});
    const release=event=>{if(pointer===event.pointerId){pointer=null;if(root.hasPointerCapture(event.pointerId))root.releasePointerCapture(event.pointerId);}};
    root.addEventListener('pointerup',release);root.addEventListener('pointercancel',release);
    root.addEventListener('lostpointercapture',()=>{pointer=null;});
    update();
  }
  document.querySelectorAll('[data-bs-reveal]').forEach(initReveal);
  document.querySelectorAll('[data-bs-reasons]').forEach(initReasons);
  document.querySelectorAll('[data-bs-product]').forEach(init);
  document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-bs-product]').forEach(init);event.target.querySelectorAll('[data-bs-reasons]').forEach(initReasons);event.target.querySelectorAll('[data-bs-reveal]').forEach(initReveal);});
})();
